export const LIVE_HELP_LEARNER_TIMEOUT_MINUTES = 2
export const LIVE_HELP_WAIT_TIME_TIMEFRAME_DAYS = 7
export const LIVE_HELP_WAIT_TIME_WITHIN_HOURS = 1
export const LIVE_HELP_DEFAULT_WAIT_TIME_MINUTES = 30
